import styled from "styled-components";

export const LayoutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media (max-width: 900px) {
    padding: 0 1rem;
  }
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: flex-start;
  background-color: #fcfaf8;
  padding: 3rem;
  border-radius: 12px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    justify-items: center;
  }
`;

export const SliderBox = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
`;

export const TableBox = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  @media (max-width: 900px) {
    max-width: 95%;
  }

  th,
  td {
    border: 0.5px solid #ccc;
    padding: 0.5rem;
    text-align: center;
  }

  /* Eerste rij (header) */
  th {
    font-weight: 1000;
    background-color: #D7A27F;
  }

  /* Eerste kolom (alle rijen) */
  td:first-child,
  th:first-child {
    font-weight: 600;
  }

  /* Hover-effect op hele rij */
  tbody tr:hover {
    background-color: #f1e3d4; /* iets donkerder, pas aan naar smaak */
    transition: background-color 0.15s ease-in-out;
  }
  
`;

export const ChartsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 3rem;
  justify-items: center;
`;

export const Section = styled.div`
  margin-bottom: 2rem;
`;


export const ChartBox = styled.div`
  width: 100%;
  max-width: 520px;
  min-height: 380px;

  background-color: #fcfaf8;
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 2rem;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Introduction = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    gap: 10vw;

    flex-wrap: wrap;

    width: 100%;
    padding: 10vw 0;
    text-align: center;
    z-index: inherit;

    /* Tablet: height */
    @media (min-width: 641px)  {
        padding: 5vw 0;
        flex-direction: row;
        gap: 5vw;
    }
`;

export const IntroductionText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1vw;


    /* Tablet: height */
    @media (min-width: 641px)  {
        width: 40vw;
    }
`;
